import React from "react";
import { PriceRange } from "../../model/PriceRange";

interface PriceRangeFilterProps {
  setSelectedPriceRanges: (selectedPriceRanges: PriceRange[]) => void;
  selectedPriceRanges: PriceRange[];
}

const PriceRangeFilter: React.FC<PriceRangeFilterProps> = ({
  setSelectedPriceRanges,
  selectedPriceRanges,
}) => (
  <>
    {[
      { min_price: -1, max_price: 500, name: "até 500 €" },
      { min_price: 500, max_price: 1000, name: "500€ - 1000€" },
      { min_price: 1000, max_price: 2000, name: "1000€ - 2000€" },
      { min_price: 2000, max_price: 3000, name: "2000€ - 3000€" },
      { min_price: 3000, max_price: -1, name: "mais de 3000€" },
    ].map((item, index) => (
      <li
        key={index}
        className={`${
          selectedPriceRanges.some(
            (range) =>
              range.min_price === item.min_price &&
              range.max_price === item.max_price,
          )
            ? "is-active has-background-info-dark has-text-white"
            : "has-background-info-light has-text-dark"
        } button text-white`}
        onClick={() => {
          const isSelected = selectedPriceRanges.some(
            (range) =>
              range.min_price === item.min_price &&
              range.max_price === item.max_price,
          );

          if (isSelected) {
            setSelectedPriceRanges(
              selectedPriceRanges.filter(
                (range) =>
                  !(
                    range.min_price === item.min_price &&
                    range.max_price === item.max_price
                  ),
              ),
            );
          } else {
            setSelectedPriceRanges([
              ...selectedPriceRanges,
              { min_price: item.min_price, max_price: item.max_price },
            ]);
          }
        }}
      >
        {item.name}
      </li>
    ))}
  </>
);

export default PriceRangeFilter;
